import Vue from 'vue';
import Router from 'vue-router'
import routers from '@/router/routers';
import {
    localToken
} from "@/libs/util";
Vue.use(Router)
    // const router = new Router({
    //     routes
    //     // mode: 'history'
    // })
const LOGIN_PAGE_NAME = 'login'
// const REGISTER_PAGE_NAME = 'register'
const INF_PAGE_NAME = 'information'

//前置操作 检测用户是否登录等 未登录通过oauth页面进行登录
routers.beforeEach((to, from, next) => {

    const token = localToken.getToken()
    if (!token && to.name !== LOGIN_PAGE_NAME) {
        // 未登录且要跳转的页面不是登录页
        next({
            name: LOGIN_PAGE_NAME // 跳转到登录页
        })
    } else if (!token && to.name === LOGIN_PAGE_NAME) {
        // 未登录且要跳转的页面是登录页
        let Tenant_Id = to.params.Tenant_Id
        localToken.setTenant(Tenant_Id);
        next()
    } 
    else {
        next() // 有权限，可访问
    }
});

export default routers;


// WEBPACK FOOTER //
// ./src/router/index.js